// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import csbEntity from './entities/csb.json';
import csbMenu from '../pages/csb/menu.json';
import csbFullForm from '../pages/csb/forms/full.json';
import csbContextForm from '../pages/csb/forms/context.json';
import csbMiniForm from '../pages/csb/forms/mini.json';
import csbLookupForm from '../pages/csb/forms/lookup.json';
import csbTableView from '../pages/csb/views/table.json';
import csbStagesView from '../pages/csb/views/stages.json';
import csbCardsView from '../pages/csb/views/cards.json';
import csbInlineView from '../pages/csb/views/inline.json';
import csbBacklogView from '../pages/csb/views/backlog.json';
import csbSplitView from '../pages/csb/views/split.json';
import csbCalendarView from '../pages/csb/views/calendar.json';
import csbDashboardView from '../pages/csb/views/dashboard.json';

/** Тип запису «Консультація» зі сторінками пакета: меню, форми та подання з pages/csb/. */
export const csbDefinition: IRecordTypeDefinition = {
  ...csbEntity,
  views: assembleViewSet({
      table: csbTableView,
      stages: csbStagesView,
      cards: csbCardsView,
      inline: csbInlineView,
      backlog: csbBacklogView,
      split: csbSplitView,
      calendar: csbCalendarView,
      dashboard: csbDashboardView,
  }),
  form: csbFullForm,
  forms: { full: csbFullForm, context: csbContextForm, mini: csbMiniForm, lookup: csbLookupForm },
  menu: csbMenu,
} as IRecordTypeDefinition;
